module.exports = __webpack_public_path__ + "static/img/iphone7-bg.f9340676.jpg";